/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BillingTransactionHistory } from '../models/BillingTransactionHistory';
import { TimeFrame } from '../models/TimeFrame';

/**
* Response containing billing transaction history
*/
export class ListBillingTransactionHistoryResponse {
  'timeFrame': TimeFrame;
  /**
  * Array of billing transaction records. Each transaction includes its cloudProvider field.
  */
  'transactions': Array<BillingTransactionHistory>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "timeFrame",
      "baseName": "timeFrame",
      "type": "TimeFrame",
      "format": ""
    },
    {
      "name": "transactions",
      "baseName": "transactions",
      "type": "Array<BillingTransactionHistory>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListBillingTransactionHistoryResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

